// extracted by mini-css-extract-plugin
export default {"group":"app-portainer-components-form-components-ButtonSelector-ButtonSelector-module__group"};